module.exports = __webpack_public_path__ + "static/media/PositiveSelfTalk.28ccabcd.png";